import { ReactNode } from "react";
import { StyledEmptyPage, StyledPageWrapper, Title } from "@monorepo/components";
import theme from "@monorepo/styles/theme";
import { Box, styled } from "@mui/material";

interface IProps {
  img: ReactNode;
  title?: string;
  success?: boolean;
  failure?: boolean;
  button?: ReactNode;
}

const StyledImg = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  maxWidth: 300,
  [theme.breakpoints.up("sm")]: {
    maxWidth: "unset",
  },
}));

export const Message: React.FC<IProps> = ({ title, img, success = false, failure = false, children, button }) => {
  return (
    <StyledPageWrapper>
      <StyledEmptyPage>
        {typeof title !== "undefined" ? (
          <Title
            noMaxWidth
            sx={{
              fontSize: {
                xs: success || failure ? theme.typography.h4.fontSize : "initial",
                xxl: success || failure ? theme.typography.h3.fontSize : "initial",
              },
              color: success ? theme.palette.primary.main : failure ? theme.palette.error.main : "initial",
            }}
          >
            {title}
          </Title>
        ) : null}
        {children}
        <StyledImg>{img}</StyledImg>
        {button && button}
      </StyledEmptyPage>
    </StyledPageWrapper>
  );
};
